import React from 'react';
import { useState, useEffect} from "react";
//import ReactDOM from 'react-dom';
import './index.css';
import App from '../src/App';
//import reportWebVitals from './reportWebVitals';


export default function Fetching() {
    const [collection, setCollection] = useState([]);
    const [userZip, setuserZip] = useState();
  
  
  useEffect(() => {
    const getData = async () => {
      const response = await fetch(`https://api.coindesk.com/v1/bpi/currentprice.json`);
  
      if (!response.ok) {
        throw new Error(response.statusText);
      }
  
      const articleData = await response.json();
  
      setCollection(articleData);
    };
    setInterval(() => {
        getData();
    }, 6000);
    }, []);

  let prices = collection.bpi;

  if (prices !== undefined) {
    return(
        <App collection={prices}/>
      );
  } else {
      return(
        <div className="App">
        <header className="App-header">
          <h1>A failed governmental response to Covid-19 has driven <a href="https://www.nbcnews.com/know-your-value/feature/what-hunger-looks-covid-19-america-ncna1242271">52M Americans</a> to food insecurity.</h1>
          </header>
      </div>
      )
  }
  }